<script setup>
import { defineProps, defineEmits, ref, computed } from "vue";
import AtomIcon from "@/common/ui/Icon.vue";
import InputWrapper from "./InputWrapper.js";

const emits = defineEmits(["update:modelValue", "keyupEnter"]);

const updateValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const props = defineProps({
  id: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  class: {
    type: String,
    default: "",
  },
  autocomplete: {
    type: String,
    default: "",
  },
  disabled: Boolean,
  modelValue: {
    type: String,
    default: "",
  },
  error: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array,
    default: () => [],
  },
  hasEditPencil: {
    type: Boolean,
    default: false,
  },
});

const onKeyupEnter = (e) => {
  emits("keyupEnter", e);
};

const isDisabled = ref(props.hasEditPencil);
const toggleDisable = () => {
  isDisabled.value = !isDisabled.value;
};
</script>

<template>
  <InputWrapper
    :id="id"
    :label="label"
    :class="props.class"
    :disabled="disabled || isDisabled"
    :error="error"
    :errors="errors"
  >
    <input
      :id="id"
      v-model="updateValue"
      :name="name"
      :autocomplete="autocomplete"
      type="text"
      :disabled="disabled || isDisabled"
      :placeholder="placeholder"
      @keyup.enter="onKeyupEnter"
    />
    <AtomIcon
      v-if="hasEditPencil && !disabled"
      name="pen"
      @click="toggleDisable"
    />
  </InputWrapper>
</template>

<style lang="scss" scoped>
@import "/src/modules/ras/views/index";
@import "../../assets/theme/default/colors";

:deep() {
  .form-control {
    display: flex;

    &--disabled {
      background-color: $white-mist-bg;
    }
  }

  .control-label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }

  .error-message {
    color: red;
    font-size: 0.75rem;
  }
}
.form-control {
  input {
    border: 0;
    flex: 1;
    &:focus {
      outline: none;
    }
  }
  .icon {
    color: $gray-medium;
    cursor: pointer;
  }
}
</style>
